const breadCrumb = "Exames - Ata do Exame";

const routes = [
  {
    path: "/ata-exame-escola",
    name: "ata-exame-escola",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/AtaExameEscola/AtaExameEscola.vue"),
  },
];

export default routes;
